var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNewProjectUseTemplate = function SvgIconNewProjectUseTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_new_project_use_template_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M9.438 3H3.25C2.007 3 1 4.1 1 5.456V7m4.5 12v-4m0-12v4m9 12v-4m0-4.5v.5m4.5 4v-4h-4.5m4.5 4v1.544C19 17.9 17.993 19 16.75 19H3.25C2.007 19 1 17.9 1 16.544V15m18 0h-4.5m0 0v-4M1 15v-4m0 4h4.5m0 0v-4m0 0V7m0 4H1m0 0V7m0 0h4.5m10.287.925.223-.51a3.94 3.94 0 0 1 2.02-2.024l.69-.305a.48.48 0 0 0 .28-.433.47.47 0 0 0-.28-.434l-.653-.287A3.95 3.95 0 0 1 16.02 1.84l-.23-.55A.46.46 0 0 0 15.362 1a.46.46 0 0 0-.428.289l-.23.549a3.95 3.95 0 0 1-2.047 2.094l-.653.288a.48.48 0 0 0-.28.433.47.47 0 0 0 .28.433l.692.304a3.94 3.94 0 0 1 2.018 2.026l.223.51a.462.462 0 0 0 .85 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_new_project_use_template_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconNewProjectUseTemplate;